import { backgroundUtils, colors } from '#packages/util';
import { EditorRestrictionsApiKey } from '#packages/apis';
import * as stateManagement from '#packages/stateManagement';

import type { MapStateToProps } from 'types/redux';
import type { SectionEmptyStateOwnProps } from './SectionEmptyState';

const PERCEIVED_LIGHTNESS_THRESHOLD = 0.5;
const isLightColor = (color: string) =>
  colors.getLumaPerceivedLightness(color) > PERCEIVED_LIGHTNESS_THRESHOLD;

export interface SectionEmptyStateStateProps {
  isLightTextColor: boolean;
  isEmptyStateAddPanelVisible: boolean;
  isEmptyStateTitleTextVisible: boolean;
  shouldDisplayAISectionGeneratorButton: boolean;
}

export const mapStateToProps: MapStateToProps<
  SectionEmptyStateStateProps,
  SectionEmptyStateOwnProps
> = ({ editorAPI, dsRead }) => {
  const backgroundData = dsRead.pages.background.get(
    dsRead.pages.getCurrentPageId(),
    'desktop',
  );

  const pageBackgroundColor = backgroundUtils.getColorValue(
    editorAPI,
    backgroundData.ref.color,
  );

  const isLightTextColor = !isLightColor(pageBackgroundColor);

  const editorRestrictionsApi = editorAPI.host.getAPI(EditorRestrictionsApiKey);
  const isEmptyStateAddPanelVisible = editorRestrictionsApi.allowed(
    'sections_empty-state-add-panel.visible',
  );
  const isEmptyStateTitleTextVisible = editorRestrictionsApi.allowed(
    'sections_empty-state-title-text.visible',
  );
  const isSchoolMode = stateManagement.schoolMode.selectors.isEnabled(
    editorAPI.store.getState(),
  );
  return {
    isLightTextColor,
    shouldDisplayAISectionGeneratorButton: !isSchoolMode,
    isEmptyStateAddPanelVisible,
    isEmptyStateTitleTextVisible,
  };
};
